import React from 'react';
import { styled } from 'styled-components';
import useRelatedArticles from '../../../../hooks/useRelatedArticles';
import Heading from '../../../Heading';
import Container from '../../../layout/Container';
import Grid from '../../../layout/Grid';
import BlogCard from '../BlogCard';
import Text from '../../../Text';
import Sections from '../../../layout/Sections';
import Background from '../../../layout/Background';

const StyledBlogRelated = styled.section`
  background-color: var(--color-iron-300);
  padding-top: var(--space-xl);
  padding-bottom: var(--space-xl);
  margin-top: var(--space-xl);
  position: relative;
  z-index: 0;
`;

export default function BlogRelated() {
  const relatedArticles = useRelatedArticles();

  return (
    <StyledBlogRelated>
      <Container>
        <Background $withContainer $cols={{ lg: 2, xl: 3 }} $lineColor="iron-400" $zIndex={-1} />
        <Sections $rowGap="baseline">
          <Heading as="h2"><Text en="Related articles" /></Heading>
          <Grid $cols={{ lg: 2, xl: 3 }} $columnGap="gutter" $rowGap="gutter">
            {relatedArticles.map((article, idx) => <BlogCard key={article.id} position={idx} article={article} summary={article.summary} />)}
          </Grid>
        </Sections>
      </Container>
    </StyledBlogRelated>
  )
}
